import {TaskCategory} from '@modifi/enums'
import {urlBuilder} from '@modifi/utilities'

import {
  ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING_COMPANY_FINANCIAL_STATEMENTS,
  ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING_GROUP_FINANCIAL_STATEMENTS,
  ROUTE_COMPANY_SELLER_TRADE_PARTNER_DOCUMENTS,
  ROUTE_COMPANY_SELLER_TRADE_PARTNER_PROFILE,
} from '../../../../routes/onboarding-routes'

export const getDocUploadLinkPattern = (category: string): string => {
  switch (category) {
    case TaskCategory.COMPANY_FINANCIAL_REVIEW:
      return ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING_COMPANY_FINANCIAL_STATEMENTS
    case TaskCategory.COMPANY_GROUP_FINANCIAL_REVIEW:
      return ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING_GROUP_FINANCIAL_STATEMENTS
    case TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_HIGH_AMOUNT_APPLICATION:
      return ROUTE_COMPANY_SELLER_TRADE_PARTNER_DOCUMENTS
    default:
      return ''
  }
}

export const getTaskUrlPath = (
  task: {
    category: string
    externalCompanyId: string
    relatedEntities?: {name?: string; key?: string}[]
  },
  isDocTask?: boolean
): string => {
  switch (task.category) {
    case TaskCategory.COMPANY_FINANCIAL_REVIEW:
      return urlBuilder(ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING_COMPANY_FINANCIAL_STATEMENTS, {
        externalCompanyId: task.externalCompanyId,
      })
    case TaskCategory.COMPANY_GROUP_FINANCIAL_REVIEW:
      return urlBuilder(ROUTE_COMPANY_FINANCIALS_YEARLY_CLOSING_GROUP_FINANCIAL_STATEMENTS, {
        externalCompanyId: task.externalCompanyId,
      })
    case TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_HIGH_AMOUNT_APPLICATION:
      if (isDocTask) {
        return urlBuilder(ROUTE_COMPANY_SELLER_TRADE_PARTNER_DOCUMENTS, {
          externalCompanyId: task.externalCompanyId,
          externalId:
            task.relatedEntities?.find(entity => entity?.name === 'TradePartnerCompany')?.key || '',
        })
      }
      return urlBuilder(ROUTE_COMPANY_SELLER_TRADE_PARTNER_PROFILE, {
        externalCompanyId: task.externalCompanyId,
        externalId:
          task.relatedEntities?.find(entity => entity?.name === 'TradePartnerCompany')?.key || '',
      })
    case TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_FOLLOW_UP:
    case TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_REALLOCATION:
    case TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_UPDATE_APPLICATION:
    case TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_MEDIUM_AMOUNT_APPLICATION:
    case 'TRADE_PARTNER_ALLOCATED_LIMIT_CHANGE_REQUEST':
      return urlBuilder(ROUTE_COMPANY_SELLER_TRADE_PARTNER_PROFILE, {
        externalCompanyId: task.externalCompanyId,
        externalId:
          task.relatedEntities?.find(entity => entity?.name === 'TradePartnerCompany')?.key || '',
      })
    default:
      return ''
  }
}
